import { makeStyles } from '@material-ui/core';

export const produtoStyles = makeStyles({
  descricaoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  descricao: {
    textOverflow: 'ellipsis',
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  badgeInativo: {
    backgroundColor: '#b53838',
    color: '#ffffff',
    margin: 0,
    marginLeft: 8,
    marginRight: 8,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 12,
    fontWeight: 600,
  },
  buttonOnOff: {
    color: 'rgba(88, 144, 170, 0.8)',
    borderRadius: '30%',
    padding: 1,
    border: 0,
    '&:hover': {
      color: 'rgba(88, 144, 170, 1)',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      color: 'rgba(88, 144, 170, 0.9)',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(88, 144, 170,0.9)',
    },
  },
});
